export default __webpack_public_path__ + "static/media/whatwg.0f10297b.svg";